<div class="modal-header">
  <h4 class="modal-title" style="font-weight: 700">{{'FAQS.title' | translate}}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)=activeModal.close()></button>
</div>
<div class="modal-body">
  <div>
    <div ngbAccordion [closeOthers]="true" style="margin: 0">
      @for (faq of faqs; track faq; let i = $index) {
        <div ngbAccordionItem>
          <h2 ngbAccordionHeader>
            <hr>
              <button ngbAccordionButton><span style="font-weight: 700">{{ faq.question }}</span></button>
            </h2>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody>
                <span [innerHTML]="faq.answer"></span>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
